import { Button, Text, Skeleton } from '@nike/eds';
import { useI18nContext } from 'context/language/use-i18n-context';
import dayjs from 'dayjs';
import ts from './i18n';
import { Policy } from '../types';
import { FC, useEffect, useState } from 'react';
import Banner from 'components/shared/banner/banner';
import './pass-availability.css';

type Props = {
  passPolicies: Policy[];
  onRequestPass: () => void;
  isModelOpen: boolean;
};

export const PassAvailablilityCard: FC<Props> = ({ passPolicies, onRequestPass, isModelOpen }) => {
  const { i18nString } = useI18nContext();
  const [totalAvailable, setTotalAvailable] = useState<{ isUnlimited: boolean; total: number }>({
    isUnlimited: false,
    total: 0,
  });

  useEffect(() => {
    let totalAvailablePasses = 0;
    for (let i = 0; i < passPolicies.length; i++) {
      const pol = passPolicies[i];
      if (pol.isUnlimited) {
        setTotalAvailable({ isUnlimited: true, total: 0 });
        break;
      } else {
        totalAvailablePasses += pol.availablePassesCount;
      }
    }
    setTotalAvailable(prev => ({ ...prev, total: totalAvailablePasses }));
  }, [passPolicies, isModelOpen === false]);

  const dateFormat = (date: Date) => {
    return dayjs(date).format('MM/DD/YY');
  };

  return passPolicies.length > 0 ? (
    <section className="eds-flex eds-flex--flex-direction-row section-cont pass_avl_section">
      <div className="eds-flex eds-flex--justify-content-center div-flex pass_avl">
        <Text as={'h1'} className="h1-100">
          {totalAvailable.isUnlimited ? String.fromCharCode(8734) : totalAvailable.total}
        </Text>
        <Text
          as={'h3'}
          color="white"
          className="txt_uppercase txt_font h3_font"
          data-testid="passes-available"
        >
          {totalAvailable.isUnlimited || totalAvailable.total
            ? i18nString(ts.INFOBOX_PASSES_AVAILABLE)
            : i18nString(ts.INFOBOX_PASS_AVAILABLE)}
        </Text>
        <ul className="eds-spacing--mt-12 passavlblty-ul">
          {passPolicies?.map(pol => {
            return (
              <li
                key={pol.displayName}
                className="eds-flex eds-flex--direction-row eds-flex--justify-content-center eds-flex--align-items-center eds-flex--wrap"
              >
                <Text as={'h3'} color="white" className="txt_uppercase txt_font">
                  {pol.availablePassesCount === 0 ? '' : pol.availablePassesCount}{' '}
                  {pol.availablePassesCount === 0
                    ? i18nString(ts.INFOBOX_UNLIMITED)
                    : pol.availablePassesCount > 0
                      ? i18nString(ts.INFOBOX_PASSES)
                      : i18nString(ts.INFOBOX_PASS)}
                </Text>
                <span className="span-separater"></span>
                <Text color="white" className="span_font" as={'span'}>
                  {pol.displayName}
                </Text>

                {!pol.isVip && (
                  <>
                    <span className="span-separater"></span>
                    <Text color="white" className="span_font" as={'span'}>
                      {dateFormat(pol.shoppingStartDate)} - {dateFormat(pol.shoppingEndDate)}
                    </Text>
                  </>
                )}
              </li>
            );
          })}
        </ul>
        <Button
          size="small"
          variant="primary"
          data-testid="request-pass"
          onClick={() => onRequestPass()}
          className="btn_green eds-spacing--my-20 txt-black"
        >
          {i18nString(ts.REQUEST_PASS)}
        </Button>
      </div>
      <Banner width="65%" />
    </section>
  ) : (
    <>
      <section className="eds-flex eds-flex--flex-direction-row section-cont">
        <div className="eds-flex eds-flex--justify-content-center div-flex">
          <div style={{ width: '100%', margin: '10px', padding: '50px', justifyItems: 'center' }}>
            <Skeleton
              data-testid="skelton-aval"
              height={150}
              width={150}
              className="eds-spacing--mr-16"
            />
            <br />
            <Skeleton height={25} width={'30%'} className="eds-spacing--mb-8" />
            <Skeleton height={25} width={'60%'} className="eds-spacing--mb-8" />
            <Skeleton height={25} width={'60%'} className="eds-spacing--mb-8" />
            <Skeleton height={25} width={'30%'} className="eds-spacing--mb-8" />
          </div>
        </div>
        <Banner width="65%" />
      </section>
    </>
  );
};
